import { Grid, Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import { GridProps } from '@mui/material/Grid';
import React from 'react';
import { ScrollableGrid } from 'spw-shared/globalComponents';
import {
  IUsfBreakdownProps,
  UsfBreakdown as UsfBreakdownDetailed,
} from 'spw-programming-projects/program-summary/single-page-summary/usf-breakdown';
import CardAtom from 'spw-components/atomic/atoms/card';

export const Card = CardAtom;

export const PaddedGrid = styled(Grid)`
  && {
    padding: 8px;
  }
`;

export const WidenedGrid = styled(ScrollableGrid)`
  && {
    width: calc(100% + 16px);
    margin: 0 -8px 8px -8px;
    scroll-margin-top: ${(props: { $scrollMarginTop?: number }) =>
      props.$scrollMarginTop || 56}px;
  }
`;

export const CardTitle = styled.div`
  && {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    color: ${colors.mainGray};
  }
`;

export const ProjectName = styled.div`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.black};
    padding-bottom: 4px;
    width: 100%;
  }
`;

export const CardSubtitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  padding-bottom: 4px;
`;

export const SubHeader = styled.div`
  && {
    font-size: 12px;
    line-height: 16px;

    letter-spacing: 0.25px;

    color: ${colors.black};
    .label {
      color: #4a4a4a;
    }

    padding-bottom: 16px;
    width: 100%;
  }
  &.no-padding {
    padding-bottom: 0px;
  }
`;

export const BigValue = styled.div<{ warning?: boolean }>`
  && {
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    /* identical to box height, or 111% */

    color: ${(props) => (props?.warning ? colors.red : colors.black)};
    padding-bottom: 8px;
  }
`;

export const AsteriskContainer = styled.div`
  position: absolute;
  right: -6px;
  top: -4px;
  font-size: 10px;
`;

export const BoldValue = styled.div`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: ${colors.black};
    min-height: 16px;
    position: relative;
  }
`;

export const BigValuePair = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    &.no-padding {
      padding-bottom: 0px;
    }
  }
`;

export const BigKey = styled.div`
  && {
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    /* Text/Hover */

    color: ${colors.mainGray};
  }
`;

export const BreakdownColumn = styled(Grid)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.25px;
    &.right {
      text-align: right;
    }
  }
`;

export const BreakdownTotalColumn = styled(BreakdownColumn)`
  color: #4a4a4a;
`;

export const BreakdownRow = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    margin-bottom: 7px;
    &.last {
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 8px;
    }
    &.bottom-and-separated {
      padding-top: 32px;
    }
  }
`;

export const Pill = styled.div`
  && {
    background-color: ${(props) => (props.color ? props.color : '#eeeeee')};
    width: 100%;
    max-height: 18px;
    margin-left: -4px;
    padding-left: 4px;
    border-radius: 11px;
    display: flex;
    justify-content: start;
    align-items: center;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
  }
`;

export const PercentValue = styled.span`
  && {
    font-weight: 500;
    padding-left: 2px;
  }
`;

export const BreakdownCardGrid = styled(Card)`
  && {
    box-sizing: border-box;
    height: 100%;
  }
`;

export const BaseValue = styled.div`
  && {
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.25px;
    color: ${colors.black};
    margin-left: 8px;
  }
`;

export const Operator = styled.div`
  && {
    font-size: 14px;

    letter-spacing: 0.25px;

    color: ${colors.black};
    margin-left: 8px;
  }
`;

export const BaseLabel = styled.div`
  && {
    font-size: 12px;
    letter-spacing: 0.25px;
    color: #4a4a4a;
    margin-left: 4px;
  }
`;

export const Highlighted = styled.div`
  && {
    display: flex;
    border-radius: 11px;
    height: 18px;
    padding: 0px 8px 0px 4px;
    margin-left: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const IconWrapper = styled.div`
  && {
    margin-right: 16px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const SeatTypeMixCategoryName = styled(Grid)`
  && {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    padding-top: 8px;
    padding-bottom: 4px;
    border-right: 1px solid #e0e0e0;
  }

  &.borderless {
    border-right: none;
  }
`;

export const SeatTypeMixColumn = styled(Grid)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #4a4a4a;
    &.padding-right-16 {
      padding-right: 16px;
    }

    &.border-right {
      border-right: 1px solid #e0e0e0;
    }
    &.border-left {
      border-left: 1px solid #e0e0e0;
    }

    &.vertical-stretch {
      border-right: 1px solid #e0e0e0;
      height: 68px;
      margin-top: -24px;
      justify-content: flex-end;
      align-items: flex-end;
      display: flex;
      padding-right: 16px;
      padding-bottom: 8px;
    }
  }
`;

export const SeatTypeMixBox = styled(Box)`
  && {
    min-height: 36px;
  }
`;

export const SeatTypeMixHeaderRow = styled(Grid)`
  && {
    display: flex;
  }
`;

export const SeatTypeMixHeader = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  padding-bottom: 8px;
  white-space: nowrap;
  &.right-border {
    border-right: 1px solid #e0e0e0;
  }
`;

export const NA = styled.div`
  && {
    font-size: 14px;
    line-height: 16px;

    color: #919191;
    margin-top: 4px;
    font-family: Roboto;
    font-weight: normal;
  }
`;

export const PercentBarContainer = styled.div`
  && {
    width: 96px;
    height: 16px;
    background-color: #eeeeee !important;
    border: none !important;
    align-self: center;
  }
`;

export const PercentBar = styled(({ ...props }) => <div {...props} />)<{
  width: number;
  color: string;
}>`
  && {
    height: 16px;
    width: ${(props) => props.width};
    background-color: ${(props) => props.color} !important;
    border: none !important;
  }
`;

export const ChildName = styled.div<{ $disableEllipsis?: boolean }>`
  && {
    font-size: 12px;
    line-height: 16px;
    max-height: 16px;
    color: ${colors.black};
    margin-left: 8px;
    white-space: nowrap;
    ${({ $disableEllipsis = false }) =>
      !$disableEllipsis
        ? `overflow: hidden;
          text-overflow: ellipsis;`
        : ''}
  }
  &.value {
    position: relative;
    overflow: visible;
  }

  &.align-right {
    text-align: right;
  }

  &.no-margin {
    margin-left: 0;
  }
`;

export const USFValue = styled.div`
  && {
    font-size: 12px;
    line-height: 16px;
    color: #4a4a4a;
    text-align: right;
    margin-right: -4px;
    white-space: nowrap;
  }
`;

export const BorderedRightChildName = styled(ChildName)`
  && {
    text-align: right;
    border-right: ${(props: { noBorder?: boolean }) =>
      props.noBorder ? 'none' : '1px solid #e0e0e0'};
    padding-bottom: 8px;
    position: relative;
  }
`;

export const UsfBreakdownDetailedCard = withStyles({
  root: {
    minHeight: 198,
  },
  breakdownRow: {
    marginBottom: 8,
  },
  last: {
    paddingBottom: '10px !important',
  },
})((props: IUsfBreakdownProps) => <UsfBreakdownDetailed {...props} />);
